/**
 * Copyright © 2020-21 Robert Bosch Engineering and Business Solutions Private Limited. All Rights Reserved.
   NOTICE:  All information contained herein is, and remains the property of Robert Bosch Engineering and Business Solutions Private
   Limited. Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is
   obtained from Robert Bosch Engineering and Business Solutions Private Limited.
*/

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CanAuthenticationGuard } from './providers/auth-guard';

const routes: Routes = [
  {
    path: '',
   loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
   canActivate: [CanAuthenticationGuard]
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    canActivate: [CanAuthenticationGuard]
  },
  {
    path: 'settings',
    loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule),
    canActivate: [CanAuthenticationGuard]
  },
  {
    path: 'accounts',
    loadChildren: () => import('./accounts/accounts.module').then(m => m.AccountsModule),
    canLoad: [CanAuthenticationGuard]
  },
  {
    path: 'tenants',
    loadChildren: () => import('./tenants/tenants.module').then(m => m.TenantsModule),
    canLoad: [CanAuthenticationGuard]
  },
  {
    path: 'users',
    loadChildren: () => import('./users/users.module').then(m => m.UsersModule),
    canLoad: [CanAuthenticationGuard]
  },
  {
    path: 'access-key',
    loadChildren: () => import('./access-keys/access-keys.module').then(m => m.AccessKeysModule),
    canLoad: [CanAuthenticationGuard]
  },
  {
    path: 'devices',
    loadChildren: () => import('./devices/devices.module').then(m => m.DevicesModule),
    canLoad: [CanAuthenticationGuard]
  },
  {
    path: 'firmware',
    loadChildren: () => import('./firmware/firmware.module').then(m => m.FirmwareModule),
    canLoad: [CanAuthenticationGuard]
  },
  {
    path: 'fota',
    loadChildren: () => import('./fota/fota.module').then(m => m.FotaModule),
    canLoad: [CanAuthenticationGuard]
  },
  {
    path: 'schedulers',
    loadChildren: () => import('./scheduler/scheduler.module').then(m => m.SchedulerModule),
    canLoad: [CanAuthenticationGuard]
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
    canLoad: [CanAuthenticationGuard]
  },
  {
    path: 'certificate',
    loadChildren: () => import('./certificate/certificate.module').then(m => m.CertificateModule),
    canLoad: [CanAuthenticationGuard]
  },
  {
    path: 'billing',
    loadChildren: () => import('./billing/billing.module').then(m => m.BillingModule),
    canLoad: [CanAuthenticationGuard]
  },
  {
    path: 'sms',
    loadChildren: () => import('./sms/sms.module').then(m => m.SmsModule),
    canLoad: [CanAuthenticationGuard]
  },
  {
    path: 'sim',
    loadChildren: () => import('./sim/sim.module').then(m => m.SimModule),
    canLoad: [CanAuthenticationGuard]
  },
  {
    path: 'whatsapp',
    loadChildren:()=> import('./whatsapp/whatsapp.module').then(m=>m.WhatsappModule),
    canLoad: [CanAuthenticationGuard]
  },
  {
    path: 'ota-advance',
    loadChildren:()=> import('./fota-advance/fota-advance.module').then(m=>m.FotaAdvanceModule),
    canLoad: [CanAuthenticationGuard]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
